import {
  type LeadsData,
  type LeadsFilters,
  type LeadsStatsOutputBodyV2,
  type LeadV2Status,
} from "../../api/generated";
import {
  createReportContext,
  type InferReport,
} from "../../context/ReportContext";

const leadsContextV2 = createReportContext({
  leadStatuses: "multi",
  countryCodes: "multi",
})<
  { leadStatuses: LeadV2Status; countryCodes: string },
  {
    table: {
      leads: LeadsData["leads"];
      totalCount: number;
      redactedFields: string[];
    };
    filters: LeadsFilters;
    stats: LeadsStatsOutputBodyV2;
    csv: void;
  },
  {
    startDate: string | undefined;
    endDate: string | undefined;
    selected: {
      leadStatuses: LeadV2Status[] | null;
      countryCodes: string[] | null;
    };
    search: string;
    page: number;
    pageSize: number;
    sortColumn: string | null;
    sortDesc: boolean | null;
  }
>();

export const {
  Provider: LeadsContextProviderV2,
  useReportContext: useLeadsContextV2,
} = leadsContextV2;

export type LeadsParamsV2 = InferReport<typeof leadsContextV2, "params">;
export type LeadsStatesV2 = InferReport<typeof leadsContextV2, "states">;
